import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export const FAQSection = () => {
  const faqs = [
    {
      question: "What happens in therapy?",
      answer: "You can read more about therapy in this",
      link: {
        text: "handout",
        url: "https://jonathanshedler.com/wp-content/uploads/2023/11/What-should-I-expect-in-therapy-Patient-Handout-R6-T.pdf"
      }
    },
    {
      question: "Can I talk to the therapist before starting sessions?",
      answer: "Absolutely, we will have a free 15 minute discovery call before starting sessions. This call is to understand what brings you to therapy. It is also a space for you to ask questions and understand if we are a good fit. There's no pressure, finding the right therapist is important!"
    },
    {
      question: "How much does one session cost?",
      answer: "My session fee is 1500 INR. We meet once a week for 60 minutes. Over time, as you feel better, we might space out sessions to a biweekly or monthly frequency."
    },
    {
      question: "How do I know if therapy is working for me?",
      answer: "Therapy is a slow process, just like building muscle or learning a new skill. You might see subtle shifts, like feeling more aware of your emotions, responding to situations differently, or just a better understanding of your self."
    },
    {
      question: "Do I have to do homework between sessions?",
      answer: "You decide! Some people find homework helpful, for others it's added stress. Let's discuss how you feel about it :)"
    },
    {
      question: "What languages can the therapist speak?",
      answer: "I speak Hindi, Marathi, and English. Feel free to speak whatever you are most comfortable in"
    },
    {
      question: "Is this confidential?",
      answer: "Yes, everything you share with me is confidential. We will talk about this in detail before starting sessions."
    }
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-lavender-50 via-blue-50 to-pink-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-800 mb-12">
          FAQs
        </h2>
        
        <div className="bg-white/70 backdrop-blur-sm rounded-3xl p-6 md:p-8 shadow-lg">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left text-lg font-medium text-gray-800 hover:text-blue-600 transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-700 leading-relaxed text-base">
                  {faq.answer}
                  {faq.link && (
                    <>
                      {' '}
                      <a 
                        href={faq.link.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:text-blue-800 underline font-medium cursor-pointer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {faq.link.text}
                      </a>
                      .
                    </>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};